// 🕊️ PATCH-498 · Single source of truth for the brand tagline.
// Retired: "One Life. One Path. One Proven Result." / "Three Phases · One Pathway".
export const TAGLINE_LINE_1 = "Serving the Last, the Least and the Lost";
export const TAGLINE_LINE_2 = "HIS Mission, HIS Mandate";
export const TAGLINE = `${TAGLINE_LINE_1}: ${TAGLINE_LINE_2}`;
export const TAGLINE_SHORT = "The Last · The Least · The Lost";
export const TAGLINE_SCRIPTURE = "Matthew 25:40 · Luke 19:10";
